import Vue from 'vue'
import Router from 'vue-router'
/**
 * 重写路由的push方法--->这个是vue-cli4.x以上的坑，不然的话，你是跳转不了的
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location)
  // return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)
let IEVersion=function() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        if(isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            console.log('---------' + fIEVersion)
            if(fIEVersion == 7) {
                return 7;
            } else if(fIEVersion == 8) {
                return 8;
            } else if(fIEVersion == 9) {
                return 9;
            } else if(fIEVersion == 10) {
                return 10;
            } else {
                return 6;//IE版本<=7
            }
        } else if(isEdge) {
            return 'edge';//edge
        } else if(isIE11) {
            return 11; //IE11
        }else{
            return -1;//不是ie浏览器
        }
}


var isPhone=navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
var isIE = (IEVersion() !=-1)&&(!isPhone)




//二级导航
let pic = function(val){
  let obj = null
  var val = val
  if(isPhone){
    obj={
      mobilechild:resolve=>require([('@/views/mobile/'+val)],resolve)
      // mobilechild:resolve=>require([('@/views/pc/'+val)],resolve)
    }
  }else{
    if(isIE){
      obj={
        pcIEChild:resolve=>require([('@/views/pcIE/'+val)],resolve)
      }
    }else{
      obj={
        pcChild:resolve=>require([('@/views/pc/'+val)],resolve)
      }
    }
	// obj={
	//   pcChild:resolve=>require([('@/views/pc/'+val)],resolve)
	// }

  }

  
  return obj
}

//一级导航
let children_not=function(val){
  console.log(val,'-----------------------')
  var val=val
  let obj=null
  if(isPhone){
    obj={
      mobile:resolve=>require([('@/views/mobile/'+val)],resolve)
    }
  }else{
    

    if(isIE){
      obj={
        pcIE:resolve=>require([('@/views/pcIE/'+val)],resolve)
      }
    }else{
      obj={
        pc:resolve=>require([('@/views/pc/'+val)],resolve)
      }
    }
    // obj={
    //   pc:resolve=>require([('@/views/pc/'+val)],resolve)
    // }

  }
  return obj
}

export default new Router({
  scrollBehavior(to,from,saveTop){

    if(saveTop){
    
    return saveTop;
    
    }else{
    
    return {x:0,y:0}
    
    } },
  routes: [
    {
      path: '*',
      redirect:''
    },
    {
      path:'/',
      name:'',
      redirect: '/home',
      components:children_not('index.vue'),
      children:[ //公用配置子路由
        {
          path:'home', //首页
          name:'home',
          components:pic('home/index.vue'),
        },
        {
          path:'quality', //质量保障
          name:'quality',
          components:pic('quality/quality.vue'),
        },
        {
          path:'expcenter', //实验中心
          name:'expcenter',
          components:pic('expcenter/expcenter.vue'),
        },
        {
          path:'about-1', //关于1
          name:'about-1',
          components:pic('about/about-1.vue'),
        },
        {
          path:'about-2', //关于2
          name:'about-2',
          components:pic('about/about-2.vue'),
        },
        {
          path:'about-3', //关于3
          name:'about-3',
          components:pic('about/about-3.vue'),
        },
        {
          path:'about-4', //关于4
          name:'about-4',
          components:pic('about/about-4.vue'),
        },
        {
          path:'about-5', //关于5
          name:'about-5',
          components:pic('about/about-5.vue'),
        },
        {
          path:'product-1', //产品1
          name:'product-1',
          components:pic('product/product-1.vue'),
        },
        {
          path:'product-2', //产品2
          name:'product-2',
          components:pic('product/product-2.vue'),
        },
        {
          path:'product-3', //产品3
          name:'product-3',
          components:pic('product/product-3.vue'),
        },
        {
          path:'product-4', //产品4
          name:'product-4',
          components:pic('product/product-4.vue'),
        },
        {
          path:'productDetail-1', //产品详细1
          name:'productDetail-1',
          components:pic('product/productDetail-1.vue'),
        },
        {
          path:'productDetail-2', //产品详细2
          name:'productDetail-2',
          components:pic('product/productDetail-2.vue'),
        },
        {
          path:'productDetail-3', //产品详细4
          name:'productDetail-3',
          components:pic('product/productDetail-3.vue'),
        },
        {
          path:'productDetail-4', //产品详细4
          name:'productDetail-4',
          components:pic('product/productDetail-4.vue'),
        },
        {
          path:'productDetail-5', //产品详细5
          name:'productDetail-5',
          components:pic('product/productDetail-5.vue'),
        },
        {
          path:'productDetail-6', //产品详细6
          name:'productDetail-6',
          components:pic('product/productDetail-6.vue'),
        },
        {
          path:'productDetail-7', //产品详细7
          name:'productDetail-7',
          components:pic('product/productDetail-7.vue'),
        },
        {
          path:'productDetail-8', //产品详细8
          name:'productDetail-8',
          components:pic('product/productDetail-8.vue'),
        },
        {
          path:'productDetail-9', //产品详细9
          name:'productDetail-9',
          components:pic('product/productDetail-9.vue'),
        },
        {
          path:'productDetail-10', //产品详细10
          name:'productDetail-10',
          components:pic('product/productDetail-10.vue'),
        },
        {
          path:'productDetail-11', //产品详细11
          name:'productDetail-11',
          components:pic('product/productDetail-11.vue'),
        },
        {
          path:'productDetail-12', //产品详细12
          name:'productDetail-12',
          components:pic('product/productDetail-12.vue'),
        },
        {
          path:'productDetail-13', //产品详细13
          name:'productDetail-13',
          components:pic('product/productDetail-13.vue'),
        },
        {
          path:'productDetail-14', //产品详细14
          name:'productDetail-14',
          components:pic('product/productDetail-14.vue'),
        },
        {
          path:'productDetail-15', //产品详细15
          name:'productDetail-15',
          components:pic('product/productDetail-15.vue'),
        },
        {
          path:'service-1', //服务中心1
          name:'service-1',
          components:pic('service/service-1.vue'),
        },
        {
          path:'service-2', //服务中心2
          name:'service-2',
          components:pic('service/service-2.vue'),
        },
        {
          path:'service-3', //服务中心3
          name:'service-3',
          components:pic('service/service-3.vue'),
        },
        {
          path:'service-4', //服务中心4
          name:'service-4',
          components:pic('service/service-4.vue'),
        },
        {
          path:'service-5', //服务中心5
          name:'service-5',
          components:pic('service/service-5.vue'),
        },
        {
          path:'contact-1', //联系1
          name:'contact-1',
          components:pic('contact/contact-1.vue'),
        },
        {
          path:'contact-2', //联系2
          name:'contact-2',
          components:pic('contact/contact-2.vue'),
        },
        {
          path:'contact-3', //联系3
          name:'contact-3',
          components:pic('contact/contact-3.vue'),
        },
        {
          path:'case-1', //案例1
          name:'case-1',
          components:pic('case/case-1.vue'),
        },
        {
          path:'case-2', //案例2
          name:'case-2',
          components:pic('case/case-2.vue'),
        },
        {
          path:'download-1', //下载1
          name:'download-1',
          components:pic('download/download-1.vue'),
        },
        {
          path:'download-2', //下载2
          name:'download-2',
          components:pic('download/download-2.vue'),
        },
        {
          path:'download-3', //下载3
          name:'download-3',
          components:pic('download/download-3.vue'),
        },
        {
          path: 'news1', // 新闻1
          name: 'news1',
          components: pic('news/news1.vue')
        },
        {
          path: 'news2', // 新闻2
          name: 'news2',
          components: pic('news/news2.vue')
        },
        {
          path: 'news3', // 新闻3
          name: 'news3',
          components: pic('news/news3.vue')
        },
        {
          path: 'news4', // 新闻4
          name: 'news4',
          components: pic('news/news4.vue')
        },
        {
          path: 'news5', // 新闻5
          name: 'news5',
          components: pic('news/news5.vue')
        },
        {
          path: 'news6', // 新闻6
          name: 'news6',
          components: pic('news/news6.vue')
        },
        {
          path: 'newsdetail-1', // 新闻详情1
          name: 'newsdetail1',
          components: pic('news/newsdetail/newsdetail-1.vue')
        },
        {
          path: 'newsdetail-2', // 新闻详情2
          name: 'newsdetail2',
          components: pic('news/newsdetail/newsdetail-2.vue')
        },
        {
          path: 'newsdetail-3', // 新闻详情3
          name: 'newsdetail3',
          components: pic('news/newsdetail/newsdetail-3.vue')
        },
        {
          path: 'newsdetail-4', // 新闻详情4
          name: 'newsdetail4',
          components: pic('news/newsdetail/newsdetail-4.vue')
        },
        {
          path: 'newsdetail-5', // 新闻详情5
          name: 'newsdetail5',
          components: pic('news/newsdetail/newsdetail-5.vue')
        },
        {
          path: 'newsdetail-6', // 新闻详情6
          name: 'newsdetail6',
          components: pic('news/newsdetail/newsdetail-6.vue')
        },
        {
          path: 'newsdetail-7', // 新闻详情7
          name: 'newsdetail7',
          components: pic('news/newsdetail/newsdetail-7.vue')
        },
        {
          path: 'newsdetail-8', // 新闻详情8
          name: 'newsdetail8',
          components: pic('news/newsdetail/newsdetail-8.vue')
        },
        {
          path: 'newsdetail-9', // 新闻详情9
          name: 'newsdetail9',
          components: pic('news/newsdetail/newsdetail-9.vue')
        },
        {
          path: 'newsdetail-10', // 新闻详情10
          name: 'newsdetail10',
          components: pic('news/newsdetail/newsdetail-10.vue')
        },
        {
          path: 'newsdetail-11', // 新闻详情11
          name: 'newsdetail11',
          components: pic('news/newsdetail/newsdetail-11.vue')
        },
        {
          path: 'recruit', // 招聘列表
          name: 'recruit',
          components: pic('recruit/list.vue')
        },
        {
          path: 'recruit/detail', // 招聘详情
          name: 'recruitDetail',
          components: pic('recruit/detail/detail.vue')
        },
      ]
    },
    //下面时时公用一级视图路由
    // {
    //   path:'/projectDetail',//案例详情
    //   name:'projectDetail',
    //   components:children_not('project/detail'),
    // }
  ],
   // mode:'history',   //去除#号
})



// WEBPACK FOOTER //
// ./src/router/index.js